import { ChevronDown, ChevronLeft, ChevronRight } from 'lucide-react';
import {
  ForestLengthGroup,
  ForestTodayButton,
  forestArrow,
  forestGroup,
} from '@/shared/components';
import { cn } from '@/shared/lib/cn';
import { rangeLabel } from './calendarLabels';
import type { CalendarZoom } from './calendarSearch';
import { ViewRangePopover } from './ViewRangePopover';

const ZOOMS = [7, 14, 30, 60] as const;

interface Props {
  from: string;
  to: string;
  zoom: CalendarZoom;
  /** Ein frei gewählter Zeitraum: dann ist keine der festen Längen gewählt. */
  custom: boolean;
  onRangeChange: (range: { from: string; to: string }) => void;
  onZoomChange: (zoom: CalendarZoom) => void;
  onPrevious: () => void;
  onNext: () => void;
  onToday: () => void;
}

/** ‹ Zeitraum ▾ › · Heute · 7/14/30/60 Tage – die Werkzeuge im Wald-Kopf der Belegung. */
export function CalendarRangeTools(props: Props) {
  return (
    <>
      <CalendarRangeStepper {...props} />
      <ForestTodayButton onToday={props.onToday} />
      <ForestLengthGroup
        values={ZOOMS}
        value={props.custom ? null : props.zoom}
        onChange={props.onZoomChange}
      />
    </>
  );
}

export function CalendarRangeStepper({
  from,
  to,
  onRangeChange,
  onPrevious,
  onNext,
}: Pick<Props, 'from' | 'to' | 'onRangeChange' | 'onPrevious' | 'onNext'>) {
  const label = rangeLabel(from, to);
  return (
    <div className={cn(forestGroup, 'h-11')}>
      <button
        type="button"
        onClick={onPrevious}
        aria-label="Vorheriger Zeitraum"
        className={forestArrow}
      >
        <ChevronLeft size={18} aria-hidden />
      </button>
      <ViewRangePopover
        from={from}
        to={to}
        label={label}
        onApply={onRangeChange}
        triggerClassName="flex h-11 items-center gap-1.5 px-1.5 font-mono text-white"
        icon={<ChevronDown size={14} aria-hidden className="order-last" />}
      />
      <button type="button" onClick={onNext} aria-label="Nächster Zeitraum" className={forestArrow}>
        <ChevronRight size={18} aria-hidden />
      </button>
    </div>
  );
}
